module.exports = __webpack_public_path__ + "img/map.c07fdd7d.png";